import { apiClient } from '@/lib/api-client'

export const deleteEnvelope = async (envelopeId: string): Promise<void> => {
  await apiClient.delete(`/v1/ecm/envelopes/${envelopeId}`)
}
